import { z } from 'zod';
import { fundingRoundSchema } from '../fundingRound/fundingRoundSchema';

export const fundingRoundsSchema = z.object({
  rounds: fundingRoundSchema.array(),
});
